// extracted by mini-css-extract-plugin
module.exports = {"productGrid":"Jf","centerLink":"Kf","productSection":"Lf","item":"Mf","ctaButton":"Nf"};